import React, { useState, useEffect, useRef } from 'react';

function ABText1(props) {

  const { label, name, id, fieldId, isRequired, errId, divClass, value, caseCheckId } = props;

  //Handling Initial States Floating Labels
  const [formData, setFormData] = useState({
    [name]: null,
  });

  useEffect(() => {

    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));

  }, [value]);

  //Handling Floating Labels
  const handleFloatingLabels = (e) => {

    setFormData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));

    props.inputText([{ "name": name, "value": e.target.value, "fieldId": fieldId, "isRequired": isRequired, "err_id": errId, "caseCheckId": caseCheckId }]);

   
  }


  // const handleChange = (selectedOption) => {

  //   props.inputText({ "name": name, "value": selectedOption.value, "fieldId": fieldId, "isRequired": isRequired, "err_id": `err-${fieldId}` });
 
  //   //setKeyword(selectedOption.name);

  // };

  let elementClass = 'col-sm-4 col-md-12 col-xl-4';
  if(divClass){
    elementClass = divClass;
  }

  return (
    <>
      <div className={elementClass}>
        <div className="form-group">
          <div className="floating-label has-left-icon">
          {value == '' ? (
          <>  
            <input type="text" className="form-control" maxLength = '40' name={name} id={id}  onChange={handleFloatingLabels} autoComplete="off"  />
            <label htmlFor={props.id ? props.id : ''} className={formData[name] && 'focused'}>{label}{isRequired && <sup className="text-danger">*</sup>}</label>
          </>
          ) : (
          <>
            <input type="text" className="form-control" maxLength = '40' name={name} id={id} value={formData[name]} onChange={handleFloatingLabels} autoComplete="off"  />
            <label htmlFor={props.id ? props.id : ''} className={value && 'focused'}>{label}{isRequired && <sup className="text-danger">*</sup>}</label>
          </>
          )}
          </div>
          <p className="err text-danger" id={errId}></p>  
        </div>
      </div>

     

    </>
  );
}

export default ABText1;
